import { initAnalytics } from '@/utils/analytics'

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  initAnalytics({
    platform:    config.public.ANALYTICS_PLATFORM as string,
    application: config.public.ANALYTICS_APPLICATION as string,
    environment: config.public.ANALYTICS_ENVIRONMENT as string,
    enabled:     config.public.ANALYTICS_ENABLED === 'true' || config.public.ANALYTICS_ENABLED === true,
  })

  // Generate or preserve the cross-domain journey_id in localStorage.
  try {
    const JOURNEY_ID_KEY = 'analytics_journey_id'
    if (!localStorage.getItem(JOURNEY_ID_KEY)) {
      localStorage.setItem(
        JOURNEY_ID_KEY,
        `j_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`
      )
    }
  } catch (_) {}

  // Always overwrite landingUrl when UTM/click-ID params are present so CRM
  // campaign clicks into an already-open tab get correct attribution.
  try {
    const params = new URLSearchParams(window.location.search)
    const hasUtm = params.has('utm_source') || params.has('utm_campaign')
        || params.has('gclid') || params.has('fbclid')
    if (hasUtm || !sessionStorage.getItem('landingUrl')) {
      sessionStorage.setItem('landingUrl', window.location.href)
    }
  } catch (err) {
    console.warn('[Analytics] Failed to initialise landing URL or journey ID:', err)
  }
})
